export default __webpack_public_path__ + "static/media/1736.5b4d5752.png";